var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCopy20(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 3.57c-.524 0-.933 0-1.266.02.025-.43.082-.734.214-.992.205-.403.533-.731.936-.937.459-.233 1.059-.233 2.259-.233h2.571c2.4 0 3.6 0 4.518.467a4.285 4.285 0 0 1 1.872 1.873c.468.917.468 2.117.468 4.517v2.571c0 1.2 0 1.8-.234 2.259a2.142 2.142 0 0 1-.936.936c-.259.132-.562.19-.993.214.02-.333.02-.742.02-1.266V8.713c0-1.8 0-2.7-.35-3.387a3.214 3.214 0 0 0-1.405-1.405c-.688-.35-1.588-.35-3.388-.35H7ZM1.662 6.884c-.233.459-.233 1.059-.233 2.259v6c0 1.2 0 1.8.233 2.259.206.403.534.73.937.936.458.234 1.058.234 2.258.234h6c1.2 0 1.8 0 2.259-.234.403-.205.73-.533.936-.936.234-.459.234-1.059.234-2.259v-6c0-1.2 0-1.8-.234-2.259a2.142 2.142 0 0 0-.936-.936c-.459-.234-1.059-.234-2.259-.234h-6c-1.2 0-1.8 0-2.258.234a2.143 2.143 0 0 0-.937.936Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy20);
export default __webpack_public_path__ + "static/media/copy_20.b6239683.svg";
export { ForwardRef as ReactComponent };